import styled, { prop }  from '@nobia/zeus-components/lib/styled'
import React, { useRef, useEffect, useState } from 'react'
import { Helmet } from '@nobia/zeus-components/lib/router'

import BadaPromo from './blocks/BadaPromo'
import Configurator from './blocks/Configurator'
import CostSummary from '../../components/costSummary/CostSummary'
import Financing from './blocks/Financing'
import Header from './blocks/Header'
import Loader from '../../components/loader/Loader'
import FinanceOverlay from '../../components/financeCalculator/FinanceOverlay'
import { BrandHeader } from '../../components/header'
import { Page } from '../../components/page'
import { useTranslation } from '../../utils/useTranslation'
import { showFinance, financeOptions, showBada } from '../../brands/monthsToPay'

const MobileCost = styled.div`
  background-color: ${prop('theme.section.bgColor')};
  position: sticky;
  z-index: 19;
  transition: top 0.325s ease;
  overflow-y: auto;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    display: none;
  }
`
const Content = styled.div`
  transition: opacity 1000ms ease;
  opacity: ${p => (p.load ? 0 : 1)};
`

const HomePage = () => {
  const [loading, setLoading] = useState(true)
  const [summary, setSummary] = useState(0)
  const [months, setMonths] = useState({ repaymentFactor: 0, months: 60 })
  const [top, setTop] = useState(0)
  const [financeOption, setFinanceOption] = useState(financeOptions[0])
  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation()
  const mobileCost = useRef()
  const params = new URLSearchParams(document.location.search)
  const isInStore = params.get('instore')

  useEffect(() => {
    if (!window) return
    window.scrollTo(0, 0)
    setTimeout(() => {
      setLoading(false)
    }, 300)
  }, [])

  const onScroll = () => {
    const athenaRoot = document.getElementById('athena-root')
    if (athenaRoot !== null) {
      if (athenaRoot.classList.contains('header--scrolled-up')) {
        setTop(74)
      } else {
        setTop(0)
      }
    }
  }

  useEffect(() => {
    onScroll()
    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'unset'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showModal])

  function metaTitle() {
    const me = document.title
      ? document.title
      : t('app.routes.main-title')
    return me
  }

  return (
    <Page header={BrandHeader}>
      {loading && <Loader />}
      <Content load={loading}>
        <Helmet title={metaTitle()} />
        <Header />
        <MobileCost ref={mobileCost} style={{ top }}>
          <CostSummary
            summary={summary}
            months={months}
            handleMonths={m => setMonths(m)}
            setShowModal={setShowModal}
            financeId={financeOption.id}
          />
        </MobileCost>
        <Configurator
          handleSummary={sum => setSummary(sum)}
          summary={summary}
          months={months}
          handleMonths={m => setMonths(m)}
          setShowModal={setShowModal}
          financeOption={financeOption}
          financeTitle={financeOption.title}
          financeId={financeOption.id}
          monthsToPayOptions={financeOption.monthsToPay}
          handleFinanceOption={f => setFinanceOption(f)}
        />
        {!isInStore &&  (showBada ? (<BadaPromo />) : (<></>)) }
        {showFinance && <Financing />}
      </Content>
      {showModal && (
        <FinanceOverlay
          setShowModal={setShowModal}
          showModal={showModal}
          summary={summary}
          financeId={financeOption.id}
          financeTitle={financeOption.title}
          interestAPR={financeOption.interestAPR}
          months={months}
        />
      )}
    </Page>
  )
}

export default HomePage
